import React from 'react';
import {ContractProjectLayout} from "../../layouts/ContractProjectHeaderLayout/ContractProjectHeaderLayout";
import {ContractorAct} from "../../containers/ContractorAct/ContractorAct";



export const PodrAdminPage = () => {
   
    return <ContractProjectLayout>
        <ContractorAct/>
    </ContractProjectLayout>
}